import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api/src/common/queryFunction';

import type { VendorQuote } from '../types';
import type {
  UseGetVendorsQuoteQueryKey,
  UseGetVendorsQuoteParams,
} from './types';
import { getUseGetVendorsQuoteQueryKey } from './utils';

export const useGetVendorQuote: QueryFunction<
  VendorQuote,
  [UseGetVendorsQuoteParams],
  UseGetVendorsQuoteQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const { vendorQuoteUuid } = params;
  const request = useRequest(requestOptions);
  const queryKey = getUseGetVendorsQuoteQueryKey(params);

  return useQuery<
    VendorQuote,
    unknown,
    VendorQuote,
    UseGetVendorsQuoteQueryKey
  >({
    queryKey,
    queryFn: ({ signal }) => {
      return request(`/vendors/vendor_quote/${params.vendorQuoteUuid}`, {
        init: {
          method: 'GET',
          signal,
        },
      });
    },
    enabled: !!vendorQuoteUuid,
    ...queryOptions,
  });
};
